// export enum ScoreColorEnum {
//   GREEN = "green",
//   RED = "red",
// }

export enum SubscriptionTypesEnum {
  BASIC = 'בסיסי',
  PREMIUM = 'פרימיום',
}

export enum StatusEnum {
  PENDING = 2,
  READY = 4,
  ACTIVE = 1,
  IN_PROGRESS = 3,
  INACTIVE = 0,
}

export enum EventAssetsManagementModesEnum {
  DOWNLOAD = 'download',
  DELETE = 'delete',
  HIDE = 'hide',
}